import React, { Component } from 'react';
import Pagination from 'src/Components/Pagination/Pagination';
import { connect } from 'react-redux';

// Components
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import RadioList from 'src/Components/RadioList/RadioList';
import SearchFieldGE from 'src/Components/SearchFieldGE/SearchFieldGE';
import PulseLoader from 'react-spinners/PulseLoader';
import SuccessToast from 'src/Components/SuccessToast/SuccessToast';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';
import {
  getFacilities,
  updateRegisterFieldValue,
  displayToast,
} from 'src/Actions/Registration/registerActions';
import { override } from './primaryFacilityConstants';

// Styles
import './styles.scss';

class PrimaryFacility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchKey: '',
      facilitiesList: [],
      isLoading: false,
      rowsPerPage: 10,
      currentPage: 1,
      selectedPrimaryFacility: '',
      selectedFacilityAddress: '',
      selectedFacilityUcmID: '',
      showToast: false,
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.props.getFacilities(this.props.ucmId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.registration.facilities !== this.props.registration.facilities
    ) {
      const facilityName = this.props.fieldValue.facilityName;
      let facilities = this.props.registration.facilities;

      if (facilities && facilities.length > 0) {
        const exceptSelectedFacility = facilities.filter(
          (x) => x.facilityName !== facilityName
        );
        const selectedFacility = facilities.filter(
          (x) => x.facilityName === facilityName
        );

        exceptSelectedFacility.splice(0, 0, selectedFacility[0]);

        facilities = exceptSelectedFacility;

        this.setState({
          isLoading: false,
          facilitiesList: facilities,
        });
      } else {
        this.setState({
          isLoading: false,
          facilitiesList: [],
        });
      }
    }

    if (
      prevProps.registration.facilitiesError !==
      this.props.registration.facilitiesError
    ) {
      this.setState({
        isLoading: false,
        facilitiesList: [],
      });
    }
  }

  handleSearch = (value) => {
    const searchQuery = value;
    this.setState({
      searchKey: searchQuery,
    });

    let facilities = this.props.registration.facilities;
    const facilityName = this.props.fieldValue.facilityName;

    if (searchQuery.length >= 2) {
      const factList = facilities.filter((facility, idx) =>
        facility.facilityName.toLowerCase().includes(value.toLowerCase())
      );
      this.setState({
        facilitiesList: factList,
      });
    } else {
      const exceptSelectedFacility = facilities.filter(
        (x) => x.facilityName !== facilityName
      );
      const selectedFacility = facilities.filter(
        (x) => x.facilityName === facilityName
      );

      exceptSelectedFacility.splice(0, 0, selectedFacility[0]);
      facilities = exceptSelectedFacility;

      this.setState({
        facilitiesList: facilities,
      });
    }
  };

  handleClear = () => {
    let facilities = this.props.registration.facilities;
    const facilityName = this.props.fieldValue.facilityName;

    if (facilities && facilities.length > 0) {
      const exceptSelectedFacility = facilities.filter(
        (x) => x.facilityName !== facilityName
      );
      const selectedFacility = facilities.filter(
        (x) => x.facilityName === facilityName
      );

      exceptSelectedFacility.splice(0, 0, selectedFacility[0]);

      facilities = exceptSelectedFacility;

      this.setState({
        searchKey: '',
        facilitiesList: facilities,
      });
    }
  };

  handleSaveClick = () => {
    const { facilityName, facilityAddress, ucmId } = this.props.fieldValue;

    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: 'SAVE SELECTION',
        linkType: 'Save Primary Facility',
      };
    }

    AnalyticsService.trackEvent('link_click');

    this.props.updateRegisterFieldValue({
      facilityName: this.state.selectedPrimaryFacility
        ? this.state.selectedPrimaryFacility
        : facilityName,
      facilityAddress: this.state.selectedFacilityAddress
        ? this.state.selectedFacilityAddress
        : facilityAddress,
      ucmId: this.state.selectedFacilityUcmID
        ? this.state.selectedFacilityUcmID
        : ucmId,
      facilityUpdated: true,
    });
    this.props.handleChangeFacilityClick();
  };

  handleFacilityClick = (args) => {
    this.setState({
      selectedPrimaryFacility: args.facilityName,
      selectedFacilityAddress: args.facilityAddress,
      selectedFacilityUcmID: args.facilityUCMId,
    });
  };

  dismissToast = () => {
    this.setState({ showToast: false });
    this.props.displayToast(false);
  };

  paginate = (e) => {
    this.setState({ currentPage: e.selected + 1 });
  };

  render() {
    const {
      searchKey,
      facilitiesList,
      isLoading,
      currentPage,
      rowsPerPage,
      showToast,
    } = this.state;

    const lastIndex = currentPage * rowsPerPage;
    const startIndex = lastIndex - rowsPerPage;
    const facilityName = this.props.fieldValue.facilityName;

    const currentRows = facilitiesList.slice(startIndex, lastIndex);
    const { t } = this.props;

    let primaryFacilityName;
    if (this.state.selectedPrimaryFacility) primaryFacilityName = this.state.selectedPrimaryFacility;
    else primaryFacilityName = facilityName;

    return (
      <div className="primary-facility-selection-wrapper">
        {showToast && (
          <div className="success-toast">
            <SuccessToast
              message={t('facilityUpdated')}
              dismissToast={this.dismissToast}
            />
          </div>
        )}
        <div className="count-search-container">
          <span className="count-container">
            {facilitiesList.length === 0
              ? '-'
              : `${facilitiesList.length} ${t('facilities')}`}
          </span>
          <SearchFieldGE
            // re={/^[a-zA-Z.' ]*$/}
            value={searchKey}
            placeholder={t('facilityName')}
            className="search-facility-input"
            onChange={this.handleSearch}
            onClear={this.handleClear}
          />
        </div>

        {isLoading ? (
          <div className="facility-loading">
            <PulseLoader
              color={'#005eb8'}
              css={override}
              style={{ marginBottom: 24, marginTop: 24 }}
            />
          </div>
        ) : (
          <Pagination
            rowsPerPage={rowsPerPage}
            totalCount={facilitiesList.length}
            paginate={this.paginate}
            lastIndex={lastIndex}
            startIndex={startIndex}
            currentPage={currentPage}
          >
            <>
              <RadioList
                dataList={currentRows}
                selectedValue={primaryFacilityName}
                onFacilityChange={this.handleFacilityClick}
              />
            </>
          </Pagination>
        )}
        <PrimaryButtonGE
          text={t('saveSelection')}
          className="save-selection-btn"
          onClick={this.handleSaveClick}
        />
      </div>
    );
  }
}

export const mapStateToProps = ({ registration }) => ({
  registration,
});

const mapDispatchToProps = (dispatch) => ({
  getFacilities: (ucmId) => dispatch(getFacilities(ucmId)),
  updateRegisterFieldValue: (fieldValue) =>
    dispatch(updateRegisterFieldValue(fieldValue)),
  displayToast: (val) => dispatch(displayToast(val)),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PrimaryFacility));
